var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_2139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3972 4.87245C16.3972 3.50229 15.3627 2.40008 14.0844 2.40008C12.3529 2.32122 10.5871 2.29077 8.78248 2.29077H8.21991C6.41969 2.29077 4.65071 2.32122 2.91925 2.40038C1.64408 2.40038 0.609579 3.50869 0.609579 4.87884C0.531444 5.96248 0.498315 7.04643 0.50019 8.13037C0.497065 9.21432 0.532486 10.2993 0.606453 11.3853C0.606453 12.7554 1.64096 13.8668 2.91612 13.8668C4.7351 13.949 6.60096 13.9855 8.49807 13.9825C10.3983 13.9885 12.259 13.95 14.08 13.8668C15.3583 13.8668 16.3928 12.7554 16.3928 11.3853C16.4678 10.2983 16.5022 9.21432 16.4991 8.12733C16.5062 7.04338 16.4722 5.95842 16.3972 4.87245ZM6.96976 11.1173V5.1343L11.5016 8.12428L6.96976 11.1173Z",
    fill: "#4E944F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_2139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.290771)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e0f79e37360b6c5222ac9d7eb7bfe2ff.svg";
export { ForwardRef as ReactComponent };